import React from "react";
import { Link } from "gatsby";
import Img from "gatsby-image";

const Series = data => {
  return (
    <article className="series-container">
      <h2 className="series-title">
        <b>{data.title}</b>
      </h2>
      {data.edges.map(post => {
        return (
          <div className="series-one-post" key={post.node.frontmatter.slug}>
            <h3 className="series-one-post-title">
              <Link to={post.node.frontmatter.slug}>
                {post.node.frontmatter.title}{" "}
                <small>(Parte {post.node.frontmatter.seriesNumber})</small>
              </Link>
            </h3>
            {post.node.frontmatter.image.extension === "svg" ? (
              <img
                className="series-one-post-image"
                src={post.node.frontmatter.image.publicURL}
                alt={post.node.frontmatter.imageAlt}
              ></img>
            ) : (
              <Img
                className="series-one-post-image"
                fluid={post.node.frontmatter.image.childImageSharp.fluid}
                alt={post.node.frontmatter.imageAlt}
              />
            )}
            <p>{post.node.frontmatter.summary}</p>
          </div>
        );
      })}
    </article>
  );
};

export default Series;
